import React from 'react';
import {Grid} from '@mui/material';
import PageWrapper from '../utils/PageWrapper';
import IconLinkList from '../ui/IconLinkList';
import {groupQuotesSubSites} from '../../config/routeItems';

function Quotes() {

    return (
        <PageWrapper siteTitle={'customerportal.navigation.quotes'} switchClient={true}>
            <Grid container
                  columnSpacing={5}
                  rowSpacing={2.5}
            >
                <Grid item
                      xs={12}
                      lg={8}
                >
                    <IconLinkList items={groupQuotesSubSites}/>
                </Grid>
                <Grid item
                      xs={12}
                      lg={4}
                      sx={{
                          position: 'relative',
                      }}
                >
                </Grid>

            </Grid>
        </PageWrapper>
    );
}

export default Quotes;
